import { CSSObject } from '@chakra-ui/react';

export const BoxPageWrapper: CSSObject = {
  px: '0',
};

export const BoxSectionWrapper: CSSObject = {
  mb: ['2', '3.5'],
  px: ['2', 0],

  _last: {
    a: {
      _last: { borderBottom: [0, 'unset'] },
    },
  },
};

export const BoxSportWrapper: CSSObject = {
  borderColor: 'transparent',
  borderRadius: 'base',
  border: 'none',
  bg: 'transparent',
  boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.15)',
};

export const TextTitle: CSSObject = {
  color: 'white',
  fontSize: 'xl',
  fontFamily: 'accent',
  fontWeight: 'normal',
};

export const LinkItem: CSSObject = {
  color: 'white',
  bg: 'rgba(78, 178, 255, 0.14)',
  border: 'none',
  borderRadius: 'md',
  boxShadow:
    '0px 0px 0px 1px rgba(255, 255, 255, 0.1) inset, 0px 4px 10px 0px rgba(0, 0, 0, 0.3)',
  h: '10',
  mb: ['1', '2'],
  _last: { mb: '0' },

  _hover: {
    bg: 'rgba(78, 178, 255, 0.45)',
  },
};

export const IconSport: CSSObject = {
  color: 'alpha.500',
  textShadow: '0px 3px 4px rgba(0, 0, 0, 0.25)',
};

export const IconChevron: CSSObject = {
  boxSize: '5',
  border: 'none',
  p: '1',
  color: 'alpha.500',
  textShadow: '0px 3px 4px rgba(0, 0, 0, 0.25)',
};

export const TextName: CSSObject = {
  fontFamily: 'accent',
  fontSize: 'sm',
  fontWeight: 'normal',
};
